import { Lightning } from "@lightningjs/sdk";
export class Button extends Lightning.Component {
    static _template() {
        return {
            w: this.W,
            alpha: 0.7,
            Button: {
                h: this.W,
                w: this.W,
                Background: {
                    h: this.W,
                    w: this.W,
                    color: 0xffffffff,
                    rect: true,
                    shader: {
                        type: Lightning.shaders.RoundedRectangle,
                        radius: this.W / 2,
                    },
                },
                Icon: {
                    color: 0xff000000,
                    texture: null,
                },
            },
        };
    }
    get callback() {
        return this._callback;
    }
    set callback(callback) {
        this._callback = callback;
    }
    get signalName() {
        return this._signalName;
    }
    set signalName(signalName) {
        this._signalName = signalName;
    }
    _focus() {
        this.patch({ alpha: 1 });
    }
    _handleEnter() {
        if (this._callback) {
            this._callback();
        }
        else if (this._signalName) {
            this.fireAncestors(this._signalName, this);
        }
        return false;
    }
    _unfocus() {
        this.patch({ alpha: 0.7 });
    }
}
Button.W = 88;
export default Button;
//# sourceMappingURL=Button.js.map